import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    multipleDates: translate({ id: 'app.header.tracking.tooltip.multipleDates' }),
    futureDates: translate({ id: 'app.header.tracking.tooltip.futureDates' }),
  }))

  return api
}
